import { render, staticRenderFns } from "./ChartFromAi.vue?vue&type=template&id=e5b5b75c&scoped=true"
import script from "./ChartFromAi.vue?vue&type=script&lang=js"
export * from "./ChartFromAi.vue?vue&type=script&lang=js"
import style0 from "./ChartFromAi.vue?vue&type=style&index=0&id=e5b5b75c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b5b75c",
  null
  
)

export default component.exports